import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import Sunburst from "./Sunburst";

type Props = {
  eyebrow: string;
  title: string;
  intro?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
};

export default function AuthShell({
  eyebrow,
  title,
  intro,
  children,
  footer,
}: Props) {
  return (
    <main
      style={{
        minHeight: "100vh",
        background: "var(--c-blush)",
        position: "relative",
        overflow: "hidden",
        display: "grid",
        placeItems: "center",
        padding: "clamp(2rem, 6vw, 4rem) var(--pad-x)",
        isolation: "isolate",
      }}
    >
      <Sunburst
        size="min(120vw, 1200px)"
        color="var(--c-coral)"
        rays={48}
        style={{
          position: "absolute",
          top: "-30%",
          right: "-32%",
          opacity: 0.22,
          zIndex: -1,
        }}
      />
      <div
        style={{
          width: "100%",
          maxWidth: 460,
          background: "var(--c-sand)",
          borderRadius: "var(--r-lg)",
          padding: "clamp(1.75rem, 4vw, 2.5rem)",
          boxShadow: "var(--shadow-card)",
        }}
      >
        <Link
          to="/"
          aria-label="Manteca Book Besties home"
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "1.25rem",
          }}
        >
          <img
            src="/brand/wordmark.png"
            alt="Manteca Book Besties"
            style={{ height: "96px", width: "auto", display: "block" }}
          />
        </Link>
        <div className="eyebrow" style={{ textAlign: "center" }}>
          {eyebrow}
        </div>
        <h1
          className="display"
          style={{
            fontSize: "clamp(2rem, 5vw, 2.6rem)",
            textAlign: "center",
            marginTop: "0.75rem",
            marginBottom: intro ? "0.75rem" : "1.5rem",
            lineHeight: 1.05,
          }}
        >
          {title}
        </h1>
        {intro && (
          <p
            style={{
              textAlign: "center",
              color: "var(--c-palm)",
              opacity: 0.85,
              marginTop: 0,
              marginBottom: "1.5rem",
              lineHeight: 1.55,
            }}
          >
            {intro}
          </p>
        )}
        {children}
      </div>
      {footer && (
        <div
          style={{
            position: "absolute",
            bottom: "1.5rem",
            left: 0,
            right: 0,
            textAlign: "center",
            color: "var(--c-palm)",
            opacity: 0.75,
            fontSize: "0.85rem",
          }}
        >
          {footer}
        </div>
      )}
    </main>
  );
}
